export const COMPLETED_REQUEST_GET_ALL = "COMPLETED_REQUEST_GET_ALL";

export const COMPLETED_REQUEST_GET_ALL_ERROR =
  "COMPLETED_REQUEST_GET_ALL_ERROR";

export const COMPLETED_REQUEST_GET_ALL_SUCCESS =
  "COMPLETED_REQUEST_GET_ALL_SUCCESS";

export const COMPLETED_REQUEST_GET_ALL_PENDING =
  "COMPLETED_REQUEST_GET_ALL_PENDING";


export const CONFIRM_EDIT_TRANSACTION =
  "CONFIRM_EDIT_TRANSACTION";

export const CONFIRM_EDIT_TRANSACTION_PENDING =
  "CONFIRM_EDIT_TRANSACTION_PENDING";

export const CONFIRM_EDIT_TRANSACTION_SUCCESS =
  "CONFIRM_EDIT_TRANSACTION_SUCCESS";

export const CONFIRM_EDIT_TRANSACTION_ERROR =
  "CONFIRM_EDIT_TRANSACTION_ERROR";